import {library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

import {
  faBrowser,
  faCheckCircle,
  faEllipsisH,
  faEnvelope,
  faGrid,
  faKey,
  faPenToSquare,
  faPlus,
  faSignOut,
  faList,
  faTriangleExclamation,
  faUserCircle,
  faUserPlus,
  faArrowUpRightFromSquare,
  faGrid2Plus,
  faTrashXmark,
  faFaceConfused,
  faMagnifyingGlass,
  faXmark,
  faBars,
} from "@fortawesome/pro-regular-svg-icons";

library.add(
  faUserCircle,
  faPenToSquare,
  faSignOut,
  faPlus,
  faEllipsisH,
  faEnvelope,
  faKey,
  faBrowser,
  faTriangleExclamation,
  faCheckCircle,
  faUserPlus,
  faList,
  faGrid,
  faArrowUpRightFromSquare,
  faGrid2Plus,
  faTrashXmark,
  faFaceConfused,
  faMagnifyingGlass,
  faXmark,
  faBars,
);

export {FontAwesomeIcon};
